import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

function formatWaktu(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export default function ParentAnnouncements() {
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/announcements/my").then((r) => setList(r.data)).catch(() => setList([]));
  }, []);

  return (
    <div className="space-y-6" data-testid="parent-announcements-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Pemberitahuan</h1>
        <p className="mt-1 text-sm text-slate-500">Pengumuman resmi dari sekolah untuk Anda dan anak Anda.</p>
      </div>

      {list === null && (
        <div className="py-16 text-center text-sm text-slate-500" data-testid="parent-announcements-loading">Memuat pengumuman...</div>
      )}

      {list !== null && list.length === 0 && (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="parent-announcements-empty">
          <Megaphone className="mx-auto mb-3 h-10 w-10 text-slate-300" strokeWidth={1.5} />
          <p className="font-heading text-lg font-semibold text-slate-800">Belum ada pengumuman</p>
          <p className="mt-1 text-sm text-slate-500">Pengumuman dari sekolah akan tampil di sini.</p>
        </div>
      )}

      <div className="space-y-3">
        {(list || []).map((a) => (
          <div key={a.id} className="rounded-xl border border-slate-200 bg-white p-5 transition-shadow duration-200 hover:shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
               data-testid={`parent-announcement-card-${a.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <h2 className="font-heading text-base font-semibold text-slate-900">{a.title}</h2>
              <div className="flex items-center gap-2">
                <Badge className="rounded-full bg-[#E5F0FA] text-[#0060AF] hover:bg-[#E5F0FA]">
                  {a.target_mode === "spp" ? "Tunggakan SPP" : a.target_mode === "tagihan" ? "Tunggakan Tagihan" : a.target_class ? `Kelas ${a.target_class}` : "Semua Siswa"}
                </Badge>
                <span className="text-xs text-slate-400">{formatWaktu(a.created_at)}</span>
              </div>
            </div>
            <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-slate-600">{a.message}</p>
            <p className="mt-3 text-xs text-slate-400">Oleh {a.created_by}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
